import { Injectable, signal } from '@angular/core';

/**
 * Seller-webshop-theme discount color (bakery-page only). Stays null for
 * marketplace/procurement, which never set it, so consumers fall back to
 * the static pink `.discount-bg`/`.text-discount` classes.
 */
@Injectable({ providedIn: 'root' })
export class DiscountThemeService {
  private readonly _color = signal<string | null>(null);
  readonly color = this._color.asReadonly();

  setColor(color: string | null | undefined): void {
    this._color.set(color || null);
  }
}
